function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vj5g7uncia"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4503",
    style: {
      fill: "#17ae7b"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "total amount-icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17878",
    style: {
      clipPath: "url(#vj5g7uncia)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 58.854v-6.677h2.672v6.677zm4.771 0V45.5h2.672v13.354zm4.771 0v-9.181h2.672v9.181z",
    transform: "translate(-41.864 -41.863)",
    style: {
      fill: "#17ae7b"
    },
    "data-name": "Group 23189"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcn);
export default __webpack_public_path__ + "static/media/sales-icn.b48729ddde3a7dc57236c0b6d1169a2c.svg";
export { ForwardRef as ReactComponent };